import React, { createContext, useState, useContext, useEffect } from 'react';
import { getDownloadURL, ref } from "firebase/storage"; // Adjust the import according to your project structure
import {storage} from './firebase';
import sample_audio_map from './sample_audio_map';
import { v4 as uuidv4 } from 'uuid';

const AudioContext = createContext();

export const useAudio = () => {
  return useContext(AudioContext);
};

export const AudioProvider = ({ children }) => {
  const [audioUrls, setAudioUrls] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAudioFiles = async () => {
      // const response = await fetch('/path/to/audioFiles.json');
      const data = sample_audio_map; //await response.json();
      const urls = {};

      for (const className in data) {
        const key = uuidv4();
        urls[className] = {};
        for (const sampleName in data[className]) {
          const filePath = data[className][sampleName];
          console.log("fetching url for %s ", filePath );
          const url = await getDownloadURL(ref(storage, filePath));
          // const key = uuidv4();
          urls[className][className+'-'+sampleName] = url;
        }
      }

      setAudioUrls(urls);
      setLoading(false);
    };

    fetchAudioFiles();
  }, []);

  return (
    <AudioContext.Provider value={{audioUrls, loading}}>
      {children}
    </AudioContext.Provider>
  );
};
